// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3XFwQ","large":"styles_large__3IJ9E"};